import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SuccessFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "2.8 2.8 26.6 26.6",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M15.9943 29.3333C23.289 29.3333 29.3334 23.2979 29.3334 16C29.3334 8.70212 23.2774 2.66667 15.9827 2.66667C8.69435 2.66667 2.66675 8.70212 2.66675 16C2.66675 23.2979 8.70596 29.3333 15.9943 29.3333ZM14.5397 22.4126C14.1381 22.4126 13.8218 22.2576 13.5119 21.8495L10.0695 17.6666C9.88607 17.443 9.78918 17.1795 9.78918 16.9158C9.78918 16.3823 10.1896 15.9573 10.7241 15.9573C11.0561 15.9573 11.3196 16.0658 11.5958 16.4456L14.4881 20.074L20.3404 10.757C20.5522 10.4005 20.8557 10.217 21.1657 10.217C21.6822 10.217 22.147 10.566 22.147 11.1124C22.147 11.3655 22.0089 11.6407 21.8592 11.8655L15.5095 21.8495C15.2577 22.2292 14.9297 22.4126 14.5397 22.4126Z"
        fill={color}
      />
      <path
        d="M14.5396 22.4126C14.138 22.4126 13.8217 22.2576 13.5118 21.8494L10.0693 17.6665C9.88596 17.443 9.78906 17.1794 9.78906 16.9158C9.78906 16.3822 10.1895 15.9572 10.724 15.9572C11.056 15.9572 11.3195 16.0658 11.5957 16.4455L14.488 20.0739L20.3403 10.757C20.5521 10.4004 20.8556 10.217 21.1655 10.217C21.6821 10.217 22.1469 10.5659 22.1469 11.1123C22.1469 11.3655 22.0088 11.6407 21.8591 11.8654L15.5094 21.8494C15.2576 22.2291 14.9296 22.4126 14.5396 22.4126Z"
        fill="transparent"
      />
    </svg>
  );
};

export { SuccessFilledSvg };
